import React, {
  useCallback,
  useMemo,
} from 'react'

import { FormattedMessage } from 'react-intl'
import PropTypes from 'prop-types'

import URL from 'utils/url'

import { useWebsite } from 'components/WebsiteProvider'

import TextLink from '../../TextLink'

import ImpressumLink from '../../ImpressumLink'

import useBannerCopy from './hooks/useBannerCopy'


export default function StandardConsentMessage(props) {
  const {
    handleShowDocument,
    handleShowPreferences,
  } = props

  const bannerMessage = useBannerCopy()
  const { policiesByType } = useWebsite()

  const handleCookiePolicyClick = useCallback(() => {
    const {
      name,
      uuid,
    } = policiesByType.Cookie

    handleShowDocument(URL.docLink(name, uuid))
  }, [handleShowDocument, policiesByType])

  const values = useMemo(() => ({
    cookiePolicyLink: makeLink({
      handleClick: handleCookiePolicyClick,
      testID: 'cookie-policy-link',
    }),
    preferencesLink: makeLink({
      handleClick: handleShowPreferences,
      testID: 'preferences-link',
    }),
  }), [handleCookiePolicyClick, handleShowPreferences])

  return (
    <>
      <FormattedMessage
        { ...bannerMessage }
        values={ values }
      />
      { ' ' }
      <ImpressumLink />
    </>
  )
}

StandardConsentMessage.propTypes = {
  handleShowDocument: PropTypes.func.isRequired,
  handleShowPreferences: PropTypes.func.isRequired,
}

function makeLink({ handleClick, testID }) {
  // eslint-disable-next-line react/display-name
  return (chunks) => (
    <TextLink
      aria-haspopup="dialog"
      data-focus-id={ testID }
      data-testid={ testID }
      handleClick={ handleClick }
    >
      { chunks }
    </TextLink>
  )
}
